import { contrastColor } from 'contrast-color';
import {
  FactoryEmaillabApiV1User,
  GoogleTypeColor
} from '../../app/apiGenerated';
import rgbHex from 'rgb-hex';

interface BadgeProps {
  type: 'light' | 'plain';
  icon?: JSX.Element;
  value?: string | number;
  color?: string;
  threshold?: number;
  size?: 'x-small' | 'small' | 'large' | undefined;
  className?: string;
  borderColor?: string;
  textColor?: string;
  onClick?: (value: string | number | undefined) => void;
}

type BadgesProps = BadgeProps & {
  items?: { value?: string | number; color?: string }[];
};

export const Badge = ({
  type,
  icon,
  value,
  color,
  threshold = 120,
  size,
  className,
  borderColor,
  textColor,
  onClick
}: BadgeProps) => {
  return (
    <span
      key={value}
      className={`slds-badge  ${
        type === 'light' ? 'slds-badge_lightest' : ''
      } ${
        size === 'small'
          ? 'slds-text-body_small'
          : size === 'x-small'
          ? 'slds-text-body_x-small'
          : ''
      } ${className !== undefined ? className : ''}`}
      style={{
        background: type === 'plain' ? color : undefined,
        color:
          textColor !== undefined
            ? textColor
            : type === 'plain'
            ? contrastColor({
                bgColor: color,
                threshold: threshold
              })
            : color !== undefined
            ? color
            : '#000',
        borderColor: borderColor,
        cursor: onClick !== undefined ? 'pointer' : 'auto'
      }}
      onClick={() => onClick?.(value)}
    >
      {icon} <span>{value}</span>
    </span>
  );
};

const Badges = ({ type, icon, items }: BadgesProps) => {
  return (
    <div className="slds-grid">
      {items &&
        items.map((item) => {
          return (
            <Badge
              type={type}
              value={item.value}
              icon={icon}
              color={item.color}
            />
          );
        })}
    </div>
  );
};

export const DisplayUser = (
  id?: string,
  users?: FactoryEmaillabApiV1User[]
) => {
  const user = users?.find((e) => e.name === id);

  return (
    <>
      {user && (
        <div className="slds-grid">
          <Badge type="plain" value={user?.display_name} />
        </div>
      )}
    </>
  );
};

export const FormatDate = (date: string | undefined) => {
  if (date === undefined) {
    return '';
  }
  const d = new Date(date);

  return d.toLocaleDateString('en-us', {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

interface GoogleColorToHexProps {
  color: GoogleTypeColor | undefined;
  defaultValue?: { r: number; g: number; b: number };
}

export const GoogleColorToHex = ({
  color,
  defaultValue
}: GoogleColorToHexProps) => {
  return (
    '#' +
    rgbHex(
      color?.red || defaultValue?.r || 0,
      color?.green || defaultValue?.g || 0,
      color?.blue || defaultValue?.b || 0
      // tagResult.data?.color?.alpha?.value || 0
    )
  );
};
